import { IBannerResponse } from "./IBannerResponse";

export const saveBanners = (payload: IBannerResponse) => ({
  type: "SAVE_BANNERS",
  payload,
});
